module.exports = __webpack_public_path__ + "50238fca79c764d59154829968980c47.jpg";